import { ProductType, ServiceType } from './API';
import { PRODUCT_TYPE_CONFIGS } from './metadata/getProductTypeConfig';

export default function getServiceTypesFromProductTypes(
  productTypes?: ProductType[] | null,
): ServiceType[] {
  if (productTypes == null) return [];
  return productTypes.flatMap((productType) => PRODUCT_TYPE_CONFIGS[productType].serviceType);
}
